/* eslint-disable @typescript-eslint/no-explicit-any */
import { getCookie, setCookie } from "@Components/Modules/Helpers";
import { hashComponents, load, murmurX64Hash128 } from "@fingerprintjs/fingerprintjs";

import { DEFAULT_CONFIG } from "./configuration-data";

const generatePCValue = () => {
    let result = "";

    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;

    for (let i = 0; i < 32; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return encodeURIComponent(result);
};

const parseLocalPC = (value: string | null) => {
    let result: Array<string>;

    if (value) {
        try {
            result = window.atob(decodeURIComponent(value).split("").reverse().join("")).split(":");
            return result;
        } catch (err) {
            console.error("Error parsing local PC value:", err);
        }
    }

    return undefined;
};

const formatLocalPC = (value: string, expireDate: Date) =>
    encodeURIComponent(
        window
            .btoa(value.concat(":").concat(expireDate.getTime().toString()))
            .replace(/=/g, "")
            .split("")
            .reverse()
            .join(""),
    );

export const initializePC = () => {
    const pcCookieValue = getCookie(DEFAULT_CONFIG.pc_name);
    const pcLocalValueParsed = parseLocalPC(localStorage.getItem(DEFAULT_CONFIG.pc_name));

    let pcValue: string | undefined;

    let pcLocalValue: string | undefined;
    let pcLocalExpireDate: number | undefined;

    if (Array.isArray(pcLocalValueParsed) && pcLocalValueParsed.length === 2) {
        pcLocalValue = pcLocalValueParsed[0];

        try {
            pcLocalExpireDate = parseInt(pcLocalValueParsed[1]);
        } catch (err) {
            console.error("Error parsing PC local expire date:", err);
        }
    }

    const pcCookieValid = pcCookieValue && pcCookieValue.length > 0;

    const pcLocalValid =
        typeof pcLocalValue === "string" &&
        pcLocalValue.length > 0 &&
        typeof pcLocalExpireDate === "number" &&
        pcLocalExpireDate > Date.now();

    if (pcCookieValid && pcLocalValid && pcCookieValue === pcLocalValue) {
        pcValue = pcLocalValue;
    } else if (!pcCookieValid && pcLocalValid) {
        pcValue = pcLocalValue;
    }

    if (!pcValue) {
        pcValue = generatePCValue();
    }

    const pcDate = new Date();

    pcDate.setMinutes(pcDate.getMinutes() + DEFAULT_CONFIG.pc_expire_minutes);
    setCookie(DEFAULT_CONFIG.pc_name, pcValue, pcDate);

    localStorage.setItem(DEFAULT_CONFIG.pc_name, formatLocalPC(pcValue, pcDate));

    return pcValue;
};

export const getFingerprintAsync = async () => {
    const componentValues: { [id: string]: any } = {};

    const dfp1Components: { [id: string]: any } = {};
    const dfp2Components: { [id: string]: any } = {};

    const fpResult = await load({
        monitoring: false,
    }).then((fp) => fp.get());

    const keys = Object.keys(fpResult.components) as (keyof typeof fpResult.components)[];

    for (const key of keys) {
        if (key === "webGlExtensions") continue;

        const component = fpResult.components[key];
        const value = (component as any).value;

        if (key === "canvas" && typeof value === "object") {
            componentValues[key] = {};

            if (typeof value.geometry !== "undefined") {
                componentValues[key].geometry = murmurX64Hash128(value.geometry);
            }

            if (typeof value.text !== "undefined") {
                componentValues[key].text = murmurX64Hash128(value.text);
            }
        } else if (typeof value !== "undefined") {
            componentValues[key] = value;
        }

        if (DEFAULT_CONFIG.components_dfp1.includes(key)) {
            dfp1Components[key] = component;
        }

        if (DEFAULT_CONFIG.components_dfp2.includes(key)) {
            dfp2Components[key] = component;
        }
    }

    componentValues.userAgent = navigator.userAgent;

    return {
        dfp1: hashComponents(dfp1Components),
        dfp2: hashComponents(dfp2Components),
        visitorId: fpResult.visitorId,
        componentValues: componentValues,
    };
};
